__turbopack_context__.v({
  "buttonStyles": "channelHeader-module-scss-module__hZ75Cq__buttonStyles",
  "channelSelectorWrapper": "channelHeader-module-scss-module__hZ75Cq__channelSelectorWrapper",
});
